module.exports = __webpack_public_path__ + "img/B.84c00483.png";